import { render } from "./UploadDialog.vue?vue&type=template&id=5053ab8a&scoped=true"
import script from "./UploadDialog.vue?vue&type=script&lang=js"
export * from "./UploadDialog.vue?vue&type=script&lang=js"

import "./UploadDialog.vue?vue&type=style&index=0&id=5053ab8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5053ab8a"]])

export default __exports__